module.exports = __webpack_public_path__ + "assets/media/phone.0fd2fa0d.jpg";